// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"60dcc515","348":"dab45ceb","546":"d7d31908","558":"09f45f59","571":"b8c16257"}[chunkId] + ".chunk.js";
};